import React from 'react';
import {Link} from "react-router-dom";

const IconButton = ({
    icon, 
    text, 
    isPrimary, 
    onClick, 
    link = false, 
    isFull = false, 
    isRed = false, 
    isDark = false, 
    className, 
    style,
    disabled = false,
    isLoading = false
}) => {

    const handleClick = (e) => {
        if (disabled || isLoading) {
            e.preventDefault();
            return;
        }
        if (onClick) {
            onClick(e);
        }
    };

    const baseClasses = `btn icon-btn ${isPrimary ? "is__primary" : "is__secondary"} ${isFull ? "full" : ""} ${isRed ? "red" : ""} ${isDark ? "black" : ""} ${className || ""}`;
    const stateClasses = `${disabled || isLoading ? "disabled" : ""} ${isLoading ? "loading" : ""}`;
    const finalClasses = `${baseClasses} ${stateClasses}`.trim();

    const LoadingSpinner = () => {
        const isDarkButton = isDark || className?.includes('black');
        const spinnerColor = isDarkButton ? '#fff' : '#3498db';
        const spinnerBgColor = isDarkButton ? 'rgba(255, 255, 255, 0.3)' : '#f3f3f3';
        
        return (
            <div 
                className="loading-spinner"
                style={{
                    width: '14px',
                    height: '14px',
                    border: `2px solid ${spinnerBgColor}`,
                    borderTop: `2px solid ${spinnerColor}`,
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    marginRight: '4px'
                }} 
            />
        );
    };

    return link ? (
        <Link 
            to={disabled || isLoading ? "#" : link} 
            className={finalClasses} 
            style={style}
            onClick={handleClick}
        >
            {isLoading ? <LoadingSpinner /> : <img src={icon} alt="icon"/>}
            <p className={"title-14"}>{text}</p>
        </Link>
    ) : (
        <div 
            className={finalClasses} 
            onClick={handleClick}  
            style={{
                ...style,
                cursor: disabled || isLoading ? 'not-allowed' : 'pointer',
                opacity: disabled || isLoading ? 0.6 : 1
            }}
        >
            {isLoading ? <LoadingSpinner /> : <img src={icon} alt="icon"/>}
            {text ? <p className={"title-14"}>{text}</p> : null}
        </div>
    )
}

export default IconButton;